import { useState } from 'react';
import RichTextEditor from '../../../components/RichTextEditor';
import { renderRichText } from '../../../utils/richText';
import { safeParseConfig } from '../blockConfig';

const DEFAULT = { prompt: '', words: [] };

// Teacher types the whole correct sentence in one field - split into the
// `words` array on save (same low-friction "type it naturally, we derive
// the structured shape" idea as FillBlankEditor's blank auto-detection),
// rather than making them add word chips one at a time like OrderingEditor
// does for its plain reference list.
export default function SentenceOrderEditor({ block, onSave, onCancel }) {
   const initial = safeParseConfig(block.config, DEFAULT);
   const [prompt, setPrompt] = useState(initial.prompt || '');
   const [sentence, setSentence] = useState(initial.words && initial.words.length ? initial.words.join(' ') : '');

   const words = sentence.trim() ? sentence.trim().split(/\s+/) : [];

   const handleSave = () => onSave({ text: sentence, config: JSON.stringify({ prompt, words }) });

   return (
      <div className='exercise-block-generic-editor'>
         <RichTextEditor rows={1} value={prompt} placeholder='Завдання (напр. Склади речення зі слів)' onChange={setPrompt} />
         {/* plain textarea, deliberately NOT RichTextEditor - this sentence is
             split on whitespace below to derive the student's word tiles, so
             any marker character (e.g. "**bold**") would land inside a tile
             or split a decorated phrase across two tiles */}
         <textarea className='exercise-block-generic-text' rows={2} value={sentence}
            placeholder='Правильне речення, напр: I go to school every day'
            onChange={e => setSentence(e.target.value)} />
         <p className='exercise-block-hint-text'>
            Студент отримає ці {words.length || 0} слів у перемішаному порядку і складатиме речення, торкаючись їх по черзі.
         </p>
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderSentenceOrderPreview(block) {
   const cfg = safeParseConfig(block.config, DEFAULT);
   if(!cfg.words || cfg.words.length === 0) return <span className='exercise-block-empty-hint'>Порожньо</span>;
   return (
      <div>
         {cfg.prompt ? <p className='exercise-block-prompt-text'>{renderRichText(cfg.prompt)}</p> : ''}
         <p className='exercise-block-text-preview'>{cfg.words.join(' ')}</p>
      </div>
   );
}
